import '../styles/index.css'
import '@hotwired/turbo'

import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'
import { initErrorReporting } from '@/lib/error-reporting'
import { loadFailedGetFormInFull } from '@/lib/failed-get-form'
import { closePopovers } from '@/lib/popover-placement'
import { reloadWhenSessionChanged } from '@/lib/session-change'
import { initTheme } from '@/lib/theme'

initErrorReporting()
initTheme()
window.addEventListener('pageshow', reloadWhenSessionChanged())
document.addEventListener('turbo:before-fetch-response', loadFailedGetFormInFull)
document.addEventListener('turbo:before-cache', closePopovers)

registerControllers(
  Application.start(),
  import.meta.glob('../controllers/*_controller.ts', { eager: true }),
)
